export const SET_SETTINGS_LOADING             = 'SET_SETTINGS_LOADING';
export const SET_SETTINGS                     = 'SET_SETTINGS';
export const SET_SUBSCRIBES                   = 'SET_SUBSCRIBES';
export const SET_REVIEWS                      = 'SET_REVIEWS';